// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 860 ? "9ebe22f4" : chunkId) + "." + {"604":"9151594d61336ffc","860":"b0249c967d5d55fc"}[chunkId] + ".js";
};